import { c as _c } from "react-compiler-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultSelectAllComponent = t0 => {
  const $ = _c(5);
  const {
    selectEverything,
    totalRowCount
  } = t0;
  let t1;
  if ($[0] !== totalRowCount) {
    t1 = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.bulkActions.selectQuery",
      options: {
        count: totalRowCount
      }
    });
    $[0] = totalRowCount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== selectEverything || $[3] !== t1) {
    t2 = /*#__PURE__*/_jsx(Button, {
      "data-test-id": "select-query-button",
      use: "link",
      onClick: selectEverything,
      children: t1
    });
    $[2] = selectEverything;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default DefaultSelectAllComponent;